// extracted by mini-css-extract-plugin
export var active = "hirek-module--active--gSJc5";
export var articleImg = "hirek-module--article-img--6GdJc";
export var articleWrapper = "hirek-module--article-wrapper--GZ5Kz";
export var hirekWrapper = "hirek-module--hirek-wrapper--2u4gI";
export var info = "hirek-module--info--TDrvd";
export var infoLink = "hirek-module--info-link--Y8x3S";
export var numberContainer = "hirek-module--number-container--3FXhO";
export var slider = "hirek-module--slider--jVNk2";
export var sliderIcon = "hirek-module--slider-icon--g3+xu";